import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { SectionCard } from '../common/SectionCard';
import { Progress } from '../ui/Progress';
import { modelPerformance, modelVersions } from '../../data/analytics';
import { formatDate } from '../../utils/format';
export function ModelPerformance() {
  return <div className="grid gap-4 xl:grid-cols-2" data-id="element-430" data-mp="3bzx8h15ysip6">
      <SectionCard title="Model performance" description="How the scoring and forecast models are performing against officer decisions" data-id="element-431" data-mp="3c18cn23bnsgt">
        <div className="space-y-4" data-id="element-432" data-mp="8jget72i8eap">
          <div data-id="element-433" data-mp="8khxnxpri52z">
            <div className="flex items-baseline justify-between" data-id="element-434" data-mp="3rosx9uamwqw">
              <p className="text-[13px]" data-id="element-435" data-mp="3pvnfxvf2ikh">Gate forecast accuracy</p>
              <span className="font-mono text-[12px]" data-id="element-436" data-mp="3uwydun3fkktn">
                {modelPerformance.gateForecastAccuracy}%
              </span>
            </div>
            <div className="mt-1.5" data-id="element-437" data-mp="w9u6uxl3ad5a">
              <Progress value={modelPerformance.gateForecastAccuracy} data-id="element-438" data-mp="rh10y6dvwyrm" />
            </div>
          </div>
          <div data-id="element-439" data-mp="1hs1eixhmagrj">
            <div className="flex items-baseline justify-between" data-id="element-440" data-mp="1htm74hkdfpmr">
              <p className="text-[13px]" data-id="element-441" data-mp="1mrw5f11e76cl">Recommendation acceptance</p>
              <span className="font-mono text-[12px]" data-id="element-442" data-mp="1mt7970uu8e3p">
                {modelPerformance.recommendationAcceptance}%
              </span>
            </div>
            <div className="mt-1.5" data-id="element-443" data-mp="1d0jfiez5mq97">
              <Progress value={modelPerformance.recommendationAcceptance} data-id="element-444" data-mp="1czhzdw3a7dkm" />
            </div>
          </div>
          <div data-id="element-445" data-mp="z4667t4rxv5t">
            <div className="flex items-baseline justify-between" data-id="element-446" data-mp="13359zaerrlvo">
              <p className="text-[13px]" data-id="element-447" data-mp="131al5l0dn9mb">Officer score override rate</p>
              <span className="font-mono text-[12px]" data-id="element-448" data-mp="p4xel6xdssmm">
                {modelPerformance.scoreOverrideRate}%
              </span>
            </div>
            <div className="mt-1.5" data-id="element-449" data-mp="2jhnafu7b8bwn">
              <Progress value={modelPerformance.scoreOverrideRate} data-id="element-450" data-mp="2jiolvzs8n0ew" />
            </div>
          </div>
          <div className="flex items-start gap-2.5 rounded-sm border border-uae-gold/40 bg-uae-gold/[0.08] px-3 py-2.5" data-id="element-451" data-mp="2ofouoigh2h9p">
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-uae-bronze" aria-hidden="true" data-id="element-452" data-mp="2n15l8xk1sq6m" />
            <p className="text-[12px] leading-relaxed text-uae-bronze" data-id="element-453" data-mp="2d1enmn06xv2b">
              {modelPerformance.driftNote}
            </p>
          </div>
        </div>
      </SectionCard>

      <SectionCard title="Model versions" description="Every scoring model release, with the accuracy measured against closed records" bodyClassName="p-0" data-id="element-454" data-mp="284eh6azfiqao">
        <ul className="divide-y divide-border" data-id="element-455" data-mp="30rr4wohbt45k">
          {modelVersions.map(version => <li key={version.version} className="px-4 py-3" data-id="element-456" data-mp="2vyfyupkc8rep">
              <div className="flex items-center justify-between gap-3" data-id="element-457" data-mp="2r1xvnu4np14h">
                <p className="font-mono text-[13px] font-medium" data-id="element-458" data-mp="3oga3gcakq2kg">{version.version}</p>
                <div className="flex items-center gap-3" data-id="element-459" data-mp="3oiek7utkmw25">
                  <span className="text-[11px] text-muted-foreground" data-id="element-460" data-mp="3jp1vlkow6p9e">
                    {formatDate(version.releasedOn)}
                  </span>
                  <span className="rounded-sm border border-uae-navy/25 bg-uae-navy/10 px-1.5 py-0.5 font-mono text-[11px] text-uae-navy" data-id="element-461" data-mp="3w02y9w7xv7sa">
                    {version.accuracy}%
                  </span>
                </div>
              </div>
              <p className="mt-1 text-[12px] leading-relaxed text-muted-foreground" data-id="element-462" data-mp="9tnuzhl19282">
                {version.note}
              </p>
            </li>)}
        </ul>
      </SectionCard>
    </div>;
}